var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('div',{staticClass:"d-flex flex-column w-100 h-100 card-inner-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }